import DeviceNotificationRoutes from "./DeviceNotificationRoutes";

export default DeviceNotificationRoutes;
